import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class RoadmapStrategyRoadmapGridController extends Controller {
  queryParams = ['column', 'row'];
  @tracked column = 'source';
  @tracked row = 'teams';
  @tracked slideoverIsOpen = false;

  @action
  setColumn(e) {
    this.column = e;
  }

  @action
  setRow(e) {
    this.row = e;
  }

  @action
  toggleFilterSlideover() {
    this.slideoverIsOpen = !this.slideoverIsOpen;
  }
}
